import BUApi from './_buApi';

class BUBudgetReserveAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUBudgetReserves';
}

export default new BUBudgetReserveAPI();
